import {
  useGetActiveParticipantAccountPaymentAccountGet,
  useListCardsPaymentAccountCardAllGet,
} from "@/api-v3";
import { type PaymentAccountResponse } from "@/features/payments/types/payment-account";

/**
 * PPS does not record a read-only Spend Card as the latest payment account, so
 * a participant can hold a usable card while GET /payment-account answers null.
 * Payment setup is therefore only outstanding when both sources are empty.
 */
export const usePaymentSetupStatus = () => {
  const {
    data: activePaymentAccount,
    isPending: isAccountPending,
    isSuccess: isAccountLoaded,
  } = useGetActiveParticipantAccountPaymentAccountGet<PaymentAccountResponse>(
    undefined,
    {
      query: { refetchOnWindowFocus: false },
    }
  );

  const {
    data: cards,
    isPending: isCardsPending,
    isSuccess: areCardsLoaded,
  } = useListCardsPaymentAccountCardAllGet({
    query: { refetchOnWindowFocus: false },
  });

  const hasPayoutAccount = activePaymentAccount != null;
  const hasCards = (cards?.data ?? []).length > 0;

  return {
    activePaymentAccount: activePaymentAccount ?? null,
    hasPayoutAccount,
    hasCards,
    // isPending, not isFetching, so a background refetch of cached data never
    // flips consumers such as the header Submit Claim button back to a skeleton.
    isLoading: isAccountPending || isCardsPending,
    needsPaymentSetup:
      isAccountLoaded && areCardsLoaded && !hasPayoutAccount && !hasCards,
  };
};
